import React, { useState } from 'react';
import { Button, Modal, Select } from 'antd';
import { SwapOutlined } from '@ant-design/icons';
import { useAppDispatch, useAppSelector } from '../store/hooks';
import { updateGroupedDraftOperations } from '../store/operations.store';
import { getMinimalVehicles } from '../store/drivers.store';

const { Option } = Select;

const VehicleSwitcher = ({ data }: { data: any }): JSX.Element => {
  const [show, setShow] = useState(false);
  const [selectedVehicle, setVehicle] = useState(data.vehicle_id);
  const minimalVehicles = useAppSelector(getMinimalVehicles);

  const dispatch = useAppDispatch();

  const handleOK = () => {
    dispatch(updateGroupedDraftOperations({ index: data.key, key: 'vehicle_id', data: selectedVehicle }));
    setShow(false);
  };

  return (
    <div>
      <Modal title="Select Vehicle" visible={show} onCancel={() => setShow(false)} onOk={handleOK} destroyOnClose>
        <Select value={selectedVehicle} className="w-100" onChange={(value) => setVehicle(value)}>
          {minimalVehicles.map((v) => (
            <Option value={v.vehicle_id} key={v.vehicle_id}>
              {v.plateNumber}
            </Option>
          ))}
        </Select>
      </Modal>
      <Button icon={<SwapOutlined />} onClick={() => setShow(true)} disabled={data.isStartingRow || data.isEndingRow} />
    </div>
  );
};

export default VehicleSwitcher;
